import styled from '@emotion/styled';
import theme from '~/theme';
import { error } from '~/styles/typography';
import BaseLink from '~/components/base/BaseLink';

export const FormSubmitWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-top: 30px;
    text-align: center;

    @media (min-width: ${theme.breakpoint.tablet}) {
        align-items: center;
        flex-direction: row;
    }
`;

export const StyledLink = styled(BaseLink)`
    font-size: 1.8rem;
    font-weight: ${theme.fontWeights.black};
    font-family: ${theme.fonts.heading};
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }

    @media (min-width: ${theme.breakpoint.largeTablet}) {
        font-size: 2rem;
    }
`;

export const AlertIcon = styled.span`
    display: inline-block;
    border-radius: 100px;
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
    background-color: ${({ isValid }) =>
        isValid ? theme.colors.accent.green : theme.colors.text.red};
    position: relative;

    &:before {
        content: '!';
        position: absolute;
        top: 50%;
        left: 7px;
        color: white;
        font-size: 1.6rem;
        font-weight: 900;
        font-family: ${theme.fonts.heading};
        transform: translateY(-50%);
    }
`;

export const FormError = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    flex-direction: column;
    text-align: center;

    p {
        ${error({ theme, size: 'large' })};
    }

    @media (min-width: ${theme.breakpoint.tablet}) {
        flex-direction: row;
        text-align: left;
    }
`;
